import { AbuseMessageDto } from './crm.type';
import axios from 'axios'
import { baseURl } from "../../../constants/config";

export const sendAbuseMessage = (abuseData: AbuseMessageDto) => {
  return axios.post(`${baseURl}/crm/report_abuse`, abuseData);
}